import { proxyCustomElement, HTMLElement, h, Host } from '@stencil/core/internal/client';

const rocheOverlineCss = ":host{display:block;margin-top:3rem;display:block}@media (min-width: 90rem){:host{margin-top:4.5rem}}:host,:host *{box-sizing:border-box}:host .overline{padding:0;color:var(--color-text--primary);font-family:\"roche-sans\";font-style:normal;font-weight:400;font-size:1.125rem;line-height:1.6875rem;color:#706b69;font-weight:400}:host .overline strong{font-weight:600}@media (min-width: 48rem){:host .overline{font-size:1.125rem;line-height:1.8125rem}}@media (min-width: 90rem){:host .overline{font-size:1.25rem;line-height:1.875rem}}";
const RocheOverlineStyle0 = rocheOverlineCss;

const RocheOverline = /*@__PURE__*/ proxyCustomElement(class RocheOverline extends HTMLElement {
    constructor() {
        super();
        this.__registerHost();
        this.__attachShadow();
        this.overlineText = undefined;
    }
    render() {
        return (h(Host, { key: '8ca729ba3b9324e057a3925afbccdafe87ac07ee' }, h("div", { key: '188a3008e9de51855cb49d21bae45dca9054d764', class: "overline" }, this.overlineText)));
    }
    static get style() { return RocheOverlineStyle0; }
}, [1, "roche-overline", {
        "overlineText": [1, "overline-text"]
    }]);
function defineCustomElement() {
    if (typeof customElements === "undefined") {
        return;
    }
    const components = ["roche-overline"];
    components.forEach(tagName => { switch (tagName) {
        case "roche-overline":
            if (!customElements.get(tagName)) {
                customElements.define(tagName, RocheOverline);
            }
            break;
    } });
}

export { RocheOverline as R, defineCustomElement as d };

//# sourceMappingURL=roche-overline2.js.map